module.exports = __webpack_public_path__ + "media/intro-h265.06e349dd.mp4";